import Vue from "vue";
import VueRouter from "vue-router";
import EventsPage from "@/views/EventsPage.vue";

Vue.use(VueRouter);

export const router = new VueRouter({
  mode: "history",
  base: "/",
  routes: [
    {
      path: "/",
      name: "home",
      component: EventsPage,
      meta: {
        authRequired: true
      }
    },
    {
      path: "/participant/:id",
      name: "participant",
      component: () => import("@/views/EventPage.vue"),
      meta: {
        authRequired: true,
        cart: true
      }
    },
    {
      path: "/participant/:id/categories",
      name: "categories",
      component: () => import("@/views/ServicesCategoriesPage.vue"),
      meta: {
        authRequired: true,
        cart: true,
        event: true
      }
    },
    {
      path: "/participant/:id/categories/:category_id",
      name: "category",
      component: () => import("@/views/CategoryPage.vue"),
      meta: {
        authRequired: true,
        cart: true,
        event: true
      }
    },
    {
      path: "/participant/:id/popular-services",
      name: "popular-services",
      component: () => import("@/views/PopularServicesPage.vue"),
      meta: {
        authRequired: true,
        cart: true,
        event: true
      }
    },
    {
      path: "/participant/:id/search",
      name: "services-search",
      component: () => import("@/views/ServicesSearchPage.vue"),
      meta: {
        authRequired: true,
        cart: true,
        event: true
      }
    },
    {
      path: "/participant/:id/cart",
      name: "cart",
      component: () => import("@/views/CartPage.vue"),
      meta: {
        authRequired: true,
        event: true
      }
    },
    {
      path: "/participant/:id/ordering",
      name: "order",
      component: () => import("@/views/OrderPage.vue"),
      meta: {
        authRequired: true,
        event: true,
        cart: true
      }
    },
    {
      path: "/participant/:id/orders",
      name: "orders",
      component: () => import("@/views/OrdersPage.vue"),
      meta: {
        authRequired: true,
        cart: true,
        event: true
      }
    },
    {
      path: "/profile",
      name: "profile",
      component: () => import("@/views/ProfilePage.vue"),
      meta: {
        authRequired: true
      }
    },
    {
      path: "/support",
      name: "support",
      component: () => import("@v2/pages/support"),
      meta: {
        authRequired: true
      }
    },
    {
      path: "/notifications",
      name: "notifications",
      component: () => import("@v2/pages/notifications")
    },
    {
      path: "/login",
      name: "login",
      meta: {
        layout: "not-auth"
      },
      component: () => import("@/views/Auth/Login.vue")
    },
    {
      path: "/logout",
      name: "logout",
      component: () => import("@/views/Auth/Logout.vue"),
      meta: {
        authRequired: true,
        layout: "not-auth"
      }
    },
    {
      path: "/recovery",
      name: "password-recovery",
      meta: {
        layout: "not-auth"
      },
      component: () => import("@/views/Auth/PasswordRecovery.vue")
    },
    {
      path: "/recovery/reset/:token",
      name: "password-recovery-reset",
      meta: {
        layout: "not-auth"
      },
      component: () => import("@/views/Auth/PasswordRecoveryReset.vue")
    },
    {
      path: "/confirm-registration/:id/:token",
      name: "confirm-registration",
      meta: {
        layout: "not-auth"
      },
      component: () => import("@/views/Auth/EmailConfirmation.vue")
    },
    {
      path: "/api/welcome/:id",
      name: "welcome",
      meta: {
        layout: "not-auth"
      },
      component: () => import("@/views/Auth/Welcome.vue")
    },
    {
      path: "/help",
      name: "help",
      meta: {
        layout: "help-form"
      },
      component: () => import("@v2/pages/appeals")
    },
    {
      path: "*",
      name: "404",
      meta: {
        layout: "empty"
      },
      component: () => import("@v2/pages/not-found")
    }
  ],
  scrollBehavior() {
    return {
      x: 0,
      y: 0
    };
  }
});
